// extracted by mini-css-extract-plugin
module.exports = {"notificationsWrapper":"src_notificationsWrapper__1LypD"};